import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Form, Modal, Row, Col, InputGroup } from "react-bootstrap";
import * as yup from "yup";
import { getCarrierData } from "../../../api/User/Hub/medicalcredentialsApi";
import Fontstyling from "../../../components/common/comman";
import {
  DeleteClientsRebatesAndReimbursementsDetails,
  SaveClientsRebatesAndReimbursementsDetail,
} from "../../../api/User/Hub/RebatesAndReimbursementsApi";
import { PlanTypeData } from "../../../Utils/constants";
import DeleteModal from "../Modal/DeleteModal";
import CustomInputField from "../CustomInputField";
import Required from "../../Required";

const RebatesAndReimbursementsModal = ({
  show,
  onHide,
  witchAction,
  user,
  client,
  updateData,
  setResponseMessage,
  getData,
}) => {
  const [CarrierData, setCarrierData] = useState([]);
  const buttonRef = useRef(null);

  const schema = yup.object().shape({
    PlanType: yup
      .string()
      .notOneOf(["Select Plan Type"], "Please select plan type")
      .required("Please select plan type"),
    PlanName: yup.string().required("Please enter plan name"),
    date: yup.date().required("Please enter date"),
    Amount: yup
      .number()
      .typeError("Please enter a valid number")
      .required("Please enter amount"),
  });
  useEffect(() => {
    getCarrier();
  }, []);

  const getCarrier = () => {
    getCarrierData().then((res) => {
      setCarrierData(() =>
        res.data.sort((a, b) => {
          if (a.CarrierName < b.CarrierName) {
            return -1;
          }
          if (a.CarrierName > b.CarrierName) {
            return 1;
          }
          return 0;
        })
      );
    });
  };

  const handelSubmit = async (e, bag) => {
    buttonRef.current.disabled = true;
    let date = new Date(e.date).toISOString();
    if (witchAction === "add") {
      let payload = {
        rebatesID: 0,
        rebatesUserID: user?.UD_id,
        rebatesClientID: client?.clientID,
        rebatesRegionID: client?.regionID,
        rebatesCategoryID: +e.PlanType,
        rebatesPlanName: e.PlanName,
        rebatesDate: date,
        rebatesAmount: +e.Amount,
      };
      await SaveClientsRebatesAndReimbursementsDetail(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          if (res.data === "Requested region is rejected") {
            setResponseMessage("rejectedRegion");
          } else {
            setResponseMessage("new");
            getData();
          }
        } else {
          setResponseMessage("failed");
        }
        bag.setValues({
          PlanType: "",
          PlanName: "",
          date: "",
          Amount: "",
        });
      });
      onHide();
    } else if (witchAction === "update") {
      let payload = {
        rebatesID: updateData?.RebatesID,
        rebatesUserID: user?.UD_id,
        rebatesClientID: client?.clientID,
        rebatesRegionID: client?.regionID,
        rebatesCategoryID: +e.PlanType,
        rebatesPlanName: e.PlanName,
        rebatesDate: date,
        rebatesAmount: +e.Amount,
      };
      await SaveClientsRebatesAndReimbursementsDetail(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          if (res.data === "Requested region is rejected") {
            setResponseMessage("rejectedRegion");
          } else {
            setResponseMessage("update");
            getData();
          }
        } else {
          setResponseMessage("failed");
        }
        bag.setValues({
          PlanType: "",
          PlanName: "",
          date: "",
          Amount: "",
        });
      });

      onHide();
    }
  };

  return (
    <Modal
      show={show}
      size={witchAction === "delete" ? "md" : "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={Fontstyling.modalHeading}
        >
          {witchAction === "add"
            ? "Add New "
            : witchAction === "update"
            ? "Update "
            : "Delete "}
          Rebates And Reimbursements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {witchAction === "delete" ? (
          <DeleteModal
            onClickYes={() => {
              DeleteClientsRebatesAndReimbursementsDetails(
                updateData.RebatesID
              );
              setResponseMessage("delete");
              onHide();
            }}
            onClickNo={() => onHide()}
          />
        ) : (
          <Formik
            validationSchema={witchAction !== "delete" && schema}
            onSubmit={handelSubmit}
            initialValues={{
              PlanType: updateData.categoryID
                ? updateData.categoryID
                : "Select Plan Type",
              PlanName: updateData ? updateData.PlanName : "",
              date:
                updateData && updateData.Date
                  ? updateData.Date.split("T")[0]
                  : "",
              Amount: updateData?.Amount ? updateData.Amount : "0",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3 gap-3">
                  <Form.Group as={Col} controlId="validationFormik07">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Plan Type <Required />
                    </Form.Label>
                    <Form.Select
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      name="PlanType"
                      value={values.PlanType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={witchAction === "delete"}
                      isInvalid={
                        values.PlanType === "Select Plan Type" &&
                        touched.PlanType
                      }
                    >
                      <option value={"Select Plan Type"}>Select</option>
                      {PlanTypeData.map((item, index) => (
                        <option value={item.value} key={index}>
                          {item.lable}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.PlanType}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="validationFormik06">
                    <Form.Label style={Fontstyling.label}>
                      Plan Name <Required />
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Plan Name"
                      name="PlanName"
                      value={values.PlanName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.PlanName && errors.PlanName}
                      disabled={witchAction === "delete"}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.PlanName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3 gap-3">
                  <Form.Group as={Col} controlId="validationFormik02">
                    <Form.Label style={Fontstyling.label}>
                      Date <Required />
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={{
                        ...Fontstyling.label,
                        textTransform: "uppercase",
                      }}
                      type="date"
                      name="date"
                      placeholder="Authorized User"
                      value={values.date}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={errors.date && touched.date}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.date}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="validationFormik09">
                    <CustomInputField
                      label={"Amount"}
                      name="Amount"
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired={true}
                      isAmount={true}
                      maxLength={15}
                    />
                    {/* <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Amount
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={{ ...Fontstyling.label }}
                      type="number"
                      name="Amount"
                      value={values.Amount}
                      placeholder="Amount"
                      onChange={handleChange}
                      disabled={witchAction === "delete"}
                      isInvalid={touched.Amount && errors.Amount}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.Amount}
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Row>
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <button
                    ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    save
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    type="reset"
                    onClick={() => {
                      // resetForm();
                      onHide();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default RebatesAndReimbursementsModal;
